import {useEffect,useState} from 'react'
import {approvalOutbox} from './api'
import {queuedApprovalText} from './approvalOutbox'
import {supabase} from '../lib/supabase'
export default function ApprovalQueueStatus({id}:{id:string}){
 const [owner,setOwner]=useState(''),[,refresh]=useState(0)
 useEffect(()=>{void supabase.auth.getSession().then(({data})=>setOwner(data.session?.user.id??''));return approvalOutbox.subscribe(()=>refresh(n=>n+1))},[])
 const entries=approvalOutbox.entries().filter(e=>e.owner===owner&&e.payload.id===id)
 if(!entries.length)return null
 return <div aria-live="polite">{entries.map(e=><p key={e.key} role={e.failed?'alert':'status'}>{e.failed?e.error:queuedApprovalText}</p>)}</div>
}
